import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import "./index.css";
import { Delete } from "@mui/icons-material";
import { removeInterval } from "../../../actions/reports-assignment";
import CustomTable from "components/common/table/CustomTable";
import formatDate from "utils/formatDate";
import ConfirmDeleteModal from "components/Modal/ConfirmDeleteModal/ConfirmDeleteModal";
import { textFilter } from "utils/table";

export default function ViewReportsAssigments(props) {
  const [showModal, setShowModal] = useState(false);
  const [currIntID, setCurrIntID] = useState("");
  const isLoading = useSelector((store) => store.loading);
  const data = useSelector((store) =>
    store.intervals.map((i) => {
      let usersNames = "";
      for (let u of i.users) {
        usersNames += `${u.name}, `;
      }
      const { startTime, endTime, id } = i;
      return {
        name: usersNames.slice(0, -2),
        startTime: new Date(startTime),
        endTime: new Date(endTime),
        id,
      };
    })
  );

  const dispatch = useDispatch();

  const openModal = (id) => {
    setCurrIntID(id);
  };
  const onConfirmModal = () => {
    dispatch(removeInterval(currIntID));
    setShowModal(false);
  };
  const onCancelModal = () => {
    setShowModal(false);
    setCurrIntID("");
  };
  useEffect(() => {
    if (currIntID) {
      setShowModal(true);
    }
  }, [currIntID]);
  const columns = [
    {
      header: "Physicians",
      accessorKey: "name",
      filterVariant: "text",
      filterFn: textFilter,
    },
    {
      header: "Start Date",
      accessorKey: "startTime",
      filterVariant: "date",
      filterFn: textFilter,
      accessorFn: (rowData) => formatDate(rowData?.startTime),
    },
    {
      header: "End Date",
      accessorKey: "endTime",
      filterVariant: "date",
      filterFn: textFilter,
      accessorFn: (rowData) => formatDate(rowData?.endTime),
    },
    {
      header: "Delete",
      accessorKey: "delete",
      accessorFn: (rowData) => {
        return (
          <>
            <Delete
              style={{ cursor: "pointer" }}
              onClick={() => {
                openModal(rowData.id);
              }}
              color="primary"
              variant="contained"
              id={rowData.id}
            />
          </>
        );
      },
    },
  ];
  return (
    <>
      {/* <Heading title={title} /> */}
      <div className="table-container">
        <CustomTable
          options={{
            state: { isLoading },
          }}
          data={data.reverse()}
          columns={columns}
        />
      </div>
      <ConfirmDeleteModal
        isModalOpen={showModal}
        onDelete={onConfirmModal}
        onClose={onCancelModal}
      />
    </>
  );
}
